import { getCookie, setCookie } from '../core'

$.fn.CookieBanner = function() {
  let self = this
  self.dismiss_button = self.find('.plus-btn')

  self.dismiss = function() {
    setCookie('cookies_banner', 'dismissed', 60*60*24*365)
    self.fadeOut(350, function() {
      self.remove()
    })
    return false
  }

  return function() {
    if (getCookie('cookies_banner') !== 'dismissed') {
      self.show()
    }
    self.dismiss_button.data('preventTransition', 1).on('click', self.dismiss)
    return self
  }()
}

export default {
  init() {
    $('.cookies-banner').each(function() {
      $(this).CookieBanner()
    })
  },

  kill() {
    //
  },
}
